import React from 'react';
import KundSection from './KundSection'
import KontakterSection from './KontokterSection'
import AvtalSection from './AvtalSection'
import OrderSection from './OrderSection'
import EventSection from './EventSection'
import AktivitetSection from './AktivitetSection'
import EsigneringSection from './EsigneringSection'
import DialerSection from './DialerSection'
function index(props) {
    

    const renderSwitch = ()=>{
        switch(parseInt(props.listNumber)){
            case 0:return <KundSection Mstate={props.Mstate} onChangeMstate={props.onChangeMstate} />
            case 1:return <KontakterSection Mstate={props.Mstate} onChangeMstate={props.onChangeMstate}/>
            case 2:return <AvtalSection Mstate={props.Mstate} onChangeMstate={props.onChangeMstate}/>
            case 3:return <OrderSection Mstate={props.Mstate} OrderStatusList={props.OrderStatusList} onChangeMstate={props.onChangeMstate}/>
            case 4:return <EventSection Mstate={props.Mstate} onChangeMstate={props.onChangeMstate}/>
            case 5:return <AktivitetSection Mstate={props.Mstate} onChangeMstate={props.onChangeMstate}/>
            case 6:return <EsigneringSection Mstate={props.Mstate} onChangeMstate={props.onChangeMstate}/>
            case 7:return <DialerSection Mstate={props.Mstate} onChangeMstate={props.onChangeMstate}/>
        }
    }
    return (
        <>
         {renderSwitch()}   
        </>
    );
}

export default index;